/* eslint-disable camelcase */
import React, { FC } from 'react';
import styles from './index.module.less';

interface DefaultBaseProps {
  baseImg: string,
  width?: number,
  title?: string,
  subTitle?: string,
  style?: any,
  containerStyle?: any,
  contentStyle?: any,
  subTitleStyle?: any,
  authorList?: {user_id: string; user_name: string}[],
}

const DefaultBase: FC<DefaultBaseProps> = ({
  baseImg, width, title, style, subTitle, containerStyle, contentStyle, subTitleStyle, authorList,
}: DefaultBaseProps) => (
  <div className={styles.container} style={{ ...containerStyle }}>
    <div className={styles.content} style={{ ...contentStyle }}>
      <div className={styles.introImg} style={{ width }}>
        <img
          src={baseImg}
          className={styles.baseImg}
          alt="洞察"
        />
      </div>
      {title && <p className={styles.introTitle} style={{ ...style }}>{title}</p>}
      {subTitle && <p className={styles.subTitle} style={{ ...subTitleStyle }}>{subTitle}</p>}
      {authorList && authorList.length > 0 && (
      <p className={styles.author}>
        <span>报告作者：</span>
        {
          authorList.map((author, index) => (
            <React.Fragment key={author.user_id}>
              <a
                href={`wxwork://message?username=${author.user_id}`}
                className={styles.wxworkLink}
              >
                <span>{`${author.user_id}(${author.user_name})${index !== authorList.length - 1 ? '；' : ''}`}</span>
              </a>
            </React.Fragment>
          ))
          }
      </p>
      )}
    </div>
  </div>
);

export default DefaultBase;
